import { colors } from "../colors";

export const lineColors = [colors["blue-300"], colors["cyan-300"], colors["indigo-300"], colors["sky-300"]];

export const trackerColors = [colors["blue-500"], colors["cyan-500"], colors["indigo-500"], colors["sky-500"]];
